import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useConfirmModal } from '@practium/ui';
import type { ParametersView } from '../types/parameters.types';
import { usePlanReferencePage } from './usePlanReferencePage';
import { useStateReferencesPage } from './useStateReferencesPage';

export const useParametersPage = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const view: ParametersView = searchParams.get('tab') === 'plan' ? 'plan' : 'states';
	const { confirm, isOpen, options, handleConfirm, handleCancel } = useConfirmModal();

	const states = useStateReferencesPage(confirm);
	const plan = usePlanReferencePage(view === 'plan', confirm);

	const setView = useCallback(
		(next: ParametersView) => setSearchParams(next === 'plan' ? { tab: 'plan' } : {}, { replace: true }),
		[setSearchParams]
	);

	return {
		view,
		states,
		plan,
		setView,
		confirmModal: { isOpen, options, handleConfirm, handleCancel },
	};
};
